import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Tab, Tabs, Button, Row, Col, Spinner, Image, Modal } from 'react-bootstrap';
import config from '../config'; // Importar config para apiBaseURL
import { useUserContext } from '../UserContext';
import { useAuthContext } from '../context/AuthContext';
import { useAppointmentsContext } from '../AppointmentsContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePacienteContext } from '../PacienteContext'; 
import axios from 'axios';
import { useAlertModal } from '../AlertModalContext';
import logoImage from '../img/logo.png';
import AgendaTab from '../components/consultorio/AgendasCardTab'; // Importar o novo componente
import PacientesTab from '../components/consultorio/PacientesTab'; // Importar o novo componente
import { useEntidadeContext } from '../EntidadeContext'; // Corrigido
import Prontuario from '../components/consultorio/Prontuario';

const Consultorio = () => {
  const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig, dynamicAccessConfig } = useUserContext();
  const { loggedInUser: currentUser, isFetchingSubscription, isSubscriptionValid } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation(); // 1. Obter a localização para ler o state
  const { showAlertModal } = useAlertModal();
  const { currentEntidade, setCurrentEntidade, isLoadingEntidade, agendaConfig, isLoadingAgendaConfig, supportData, isLoadingSupportData, addPacienteToList } = useEntidadeContext();
  const { 
    // NOVO: Estado para controlar o bloqueio de tela durante operações críticas
    isScreenLocked, setIsScreenLocked,
    pacienteSelecionado, 
    setPacienteSelecionado, 
    setFotoAntesProntuario, 
    setFotoDepoisProntuario,
    lastActivePatientContext, setLastActivePatientContext // Consumir para Retomar Atendimento
    , triggerRefreshAppointments // NOVO: Obter a função de gatilho
  } = usePacienteContext(); 

  // --- RESPONSIVIDADE ---
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 576;
  const isTablet = windowWidth >= 576 && windowWidth < 992;
  const isMdDevice = windowWidth >= 768 && windowWidth < 992;

  // Estados para os dados do Prontuário, agora gerenciados pelo Consultorio
  const [prontuarioData, setProntuarioData] = useState({ historico: [], consultaAtual: null });
  const lastSetProntuarioDataRef = useRef(null); // Ref to store the last set prontuarioData content
  const allAppointmentsFetchedRef = useRef(null); // Ref para evitar re-fetch de todos os agendamentos
  const prontuarioFetchedForIdRef = useRef(null); // Ref para evitar re-fetch do prontuário

  const { appointments, setAppointments } = useAppointmentsContext();
  const [paciente, setPaciente] = useState({
    id: '',
    nome: '',
    dataNascimento: '',
    cpf: '',
    email: '',
    agendamento_updated_at:'',
    agendamento_status:'',
    duracao_atendimento:'',
    data_agendamento: '', // Adiciona estado inicial
    hora_marcada: '', // Adiciona estado inicial
    foto_path: null, // Adicionar para consistência, embora usemos pacienteSelecionado diretamente para a foto
  });

  // Estados para controle do calendário e agendamentos (movidos de AgendasTab)
  const [selectedEspecialidade, setSelectedEspecialidade] = useState('');
  const [selectedMedico, setSelectedMedico] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [calendarAppointments, setCalendarAppointments] = useState([]); // Agendamentos do dia selecionado
 const [isLoadingCalendarData, setIsLoadingCalendarData] = useState(false); // Novo estado de loading para dados do calendário
  

 const [agendaRefreshKey, setAgendaRefreshKey] = useState(0); // NOVO: Chave para forçar atualização da agenda

 // Estados para a aba "Ordem de Chegada"
 const [ordemDeChegada, setOrdemDeChegada] = useState([]);
 const [isLoadingOrdemDeChegada, setIsLoadingOrdemDeChegada] = useState(false);

  // Interceptor global para erros de assinatura, agora no lugar correto
  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response, // Passa adiante respostas de sucesso
      (error) => {
        // Verifica se o erro é de 'Forbidden' e se a mensagem é sobre assinatura inativa
        if (error.response && error.response.status === 403 && error.response.data?.message?.includes('Sua assinatura não está ativa')) {
          const message = error.response.data.message;

          // Exibe um modal para o usuário e oferece redirecionamento
          showAlertModal(
            'Assinatura Inativa',
            `${message} Clique em OK para ser redirecionado à página de planos.`,
            'warning',
            () => navigate('/pricing') // Ação ao clicar em OK
          );

          // Importante: Rejeita a promessa para que a chamada original da API ainda falhe
          return Promise.reject(error);
        }
        // Para todos os outros erros, apenas os repasse para serem tratados localmente
        return Promise.reject(error);
      }
    );

    // Função de limpeza para remover o interceptor quando o componente é desmontado
    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [showAlertModal, navigate]);

  // Efeito para verificar se a agenda foi configurada ao entrar no consultório.
  useEffect(() => {
    // Roda apenas quando os dados da entidade e da agenda terminarem de carregar.
    // E somente se o usuário for um Representante Legal e a ASSINATURA FOR VÁLIDA.
    if (
      !isLoadingEntidade && 
      !isLoadingAgendaConfig && 
      isSubscriptionValid && // <-- CONDIÇÃO CORRIGIDA: Garante que a assinatura permite o uso.
      currentEntidade && 
      currentUserRole === 'Representante Legal'
    ) {
      // Verifica se o objeto de horários gerados existe e se algum dia da semana tem pelo menos um horário cadastrado.
      const horariosGerados = currentEntidade.agenda_horarios_gerados;
      const isAgendaConfigurada = horariosGerados && 
        Object.values(horariosGerados).some(dia => 
            (dia['Manhã'] && dia['Manhã'].length > 0) ||
            (dia['Tarde'] && dia['Tarde'].length > 0) ||
            (dia['Noite'] && dia['Noite'].length > 0)
        );

      // Se não estiver configurada, exibe o alerta e redireciona.
      if (!isAgendaConfigurada) {
        showAlertModal(
          'Configuração da Agenda Pendente',
          'Os horários de atendimento da sua clínica ainda não foram definidos. Isso é essencial para usar a agenda. Clique em OK para configurar agora.',
          'warning',
          () => navigate('/configuracoes') // Redireciona para a página de configurações
        );
      }
    }
  }, [currentEntidade, isLoadingEntidade, isLoadingAgendaConfig, isFetchingSubscription, currentUserRole, showAlertModal, navigate]);

  // Os horários de atendimento agora são pré-gerados no backend e consumidos do contexto da entidade.
  const horariosAtendimento = useMemo(() => {
    if (!currentEntidade?.agenda_horarios_gerados) {
        // Retorna um estado de carregamento ou padrão se os dados ainda não estiverem disponíveis.
        return { 'Manhã': [], 'Tarde': [], 'Noite': [] };
    }
    const diaDaSemana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'][selectedDate.getDay()];
    return currentEntidade.agenda_horarios_gerados[diaDaSemana] || { 'Manhã': [], 'Tarde': [], 'Noite': [] };
  }, [currentEntidade, selectedDate]);

  const totalSlotsDisponiveis = useMemo(() => Object.values(horariosAtendimento).reduce(
    (total, horarios) => total + horarios.length, 0
  ), [horariosAtendimento]);

  // Função para verificar se uma data é feriado (agora busca do estado)
  const getFeriadoNome = useCallback((date) => { 
    if (!date || !agendaConfig.feriados) return null;
    // A API retorna a data no formato 'YYYY-MM-DD'. O objeto Date do JS pode ter problemas de fuso.
    // A forma mais segura é comparar strings no formato YYYY-MM-DD.
    const dateString = date.toISOString().split('T')[0];
    const feriado = agendaConfig.feriados.find(f => f.data === dateString);
    return feriado ? feriado.descricao : null;
  }, [agendaConfig]);

  // Callback para ADICIONAR um novo paciente na lista sem recarregar tudo
  const handlePatientCreated = useCallback((newPatient) => {
    addPacienteToList(newPatient); // Usa a função do contexto para atualizar a lista global
    showAlertModal('Sucesso', `Paciente "${newPatient.nome}" criado com sucesso!`, 'success');
    // Opcional: Se este for o primeiro paciente, pode ser necessário atualizar o estado da entidade
    if (currentEntidade && !currentEntidade.has_pacientes) {
      setCurrentEntidade(prev => ({ ...prev, has_pacientes: true, pacientes_count: (prev.pacientes_count || 0) + 1 }));
    }
  }, [currentEntidade, setCurrentEntidade, showAlertModal, addPacienteToList]);

  // Callback para ATUALIZAR um paciente na lista sem recarregar tudo
  const handlePatientUpdate = useCallback((updatedPatient) => {
    // A lista de pacientes agora é gerenciada pelo EntidadeContext.
    showAlertModal('Sucesso', `Paciente "${updatedPatient.nome}" atualizado com sucesso!`, 'success');
  }, [showAlertModal]); // A dependência showAlertModal é estável

  // Callback para DELETAR um paciente da lista sem recarregar tudo
  const handlePatientDeleted = useCallback((deletedPatientId) => {
    // A lista de pacientes agora é gerenciada pelo EntidadeContext.
    showAlertModal('Sucesso', 'Paciente excluído com sucesso!', 'success');
  }, [showAlertModal]);
  
  // Memo para verificar se o usuário logado é do corpo clínico
  const isCurrentUserCorpoClinico = useMemo(() => {
    if (!currentUser || !currentUser.id || !supportData.todosMedicos || supportData.todosMedicos.length === 0) {
      return false;
    }
    return supportData.todosMedicos.some(medico => medico.id === currentUser.id);
  }, [currentUser, supportData.todosMedicos]);

  // Efeito para definir o médico automaticamente se o usuário logado for do Corpo Clínico
  useEffect(() => {
    if (isCurrentUserCorpoClinico && currentUser?.id && supportData.todosMedicos?.length > 0) {
      const medicoLogado = supportData.todosMedicos.find(m => m.id === currentUser.id);
      if (medicoLogado) {
        // Define tanto o médico quanto a especialidade dele.
        setSelectedMedico(medicoLogado.id.toString());
        if (medicoLogado.especialidade_id) {
          setSelectedEspecialidade(medicoLogado.especialidade_id.toString());
        }
      }
    }
  }, [isCurrentUserCorpoClinico, currentUser, supportData.todosMedicos]); // As dependências estão corretas. Os setters de estado são estáveis.

  // Função para verificar se uma data é um dia bloqueado (agora busca do estado)
  const isDiaBloqueado = useCallback((date) => {
    if (!date || !agendaConfig.diasBloqueados) return false;
    const dateString = date.toISOString().split('T')[0];
    return agendaConfig.diasBloqueados.some(b => b.data === dateString);
  }, [agendaConfig]);

  // Função para buscar a ordem de chegada
  const fetchOrdemDeChegada = useCallback(async () => {
    // A busca só faz sentido se o usuário for um médico
    if (!isCurrentUserCorpoClinico || !currentUser?.id || !currentEntidade) {
      setOrdemDeChegada([]);
      return;
    }

    setIsLoadingOrdemDeChegada(true);
    try {
      const formattedDate = selectedDate.toISOString().split('T')[0];
      // Ajuste na URL para corresponder à rota da API: /medicos/{medicoId}/ordem-chegada/{data}
      const response = await axios.get(`/api/medicos/${currentUser.id}/ordem-chegada/${formattedDate}`);
      setOrdemDeChegada(response.data.agendamentos || []); // Ajustado para 'agendamentos' para corresponder à resposta da API
      
    } catch (error) {
      console.error("[Consultorio.js] Erro ao buscar ordem de chegada:", error);
      // Não mostrar alerta para 404, pois pode ser normal não haver agendamentos.
      setOrdemDeChegada([]);
    } finally {
      setIsLoadingOrdemDeChegada(false);
    }
  }, [isCurrentUserCorpoClinico, currentUser?.id, selectedDate, currentEntidade, showAlertModal]);

  // useEffect para filtrar os agendamentos do médico selecionado a partir da lista completa
  useEffect(() => {
    if (selectedMedico) {
      // A filtragem agora acontece dentro do AgendasCardTab ou via API
      // setCalendarAppointments(filtered); 
    } else {
      // Se nenhum médico estiver selecionado (visão de recepção/admin sem filtro),
      // pode-se optar por mostrar todos ou nenhum na grade principal.
      // Vamos limpar para evitar confusão.
      setCalendarAppointments([]);
    }
  }, [selectedMedico]);

  // Callback central para ATUALIZAR TODAS AS LISTAS após uma ação do usuário (ex: criar, finalizar)
    const handleAppointmentStatusUpdated = useCallback(async (updatedAppointment) => {
    // Otimização: Se recebemos o agendamento atualizado (vindo do AgendasTab),
    // atualizamos o estado localmente em vez de fazer um re-fetch completo.
    
    if (updatedAppointment) {
      if (pacienteSelecionado && updatedAppointment.id === pacienteSelecionado.agendamento_id) {
        // O objeto `updatedAppointment` já contém a `consulta` com os `servicos` atualizados.
        // Nós o injetamos diretamente no `pacienteSelecionado`.

        // --- INÍCIO DA CORREÇÃO ---
        // Se o agendamento atualizado tem uma consulta, atualizamos o prontuarioData.
        // Isso força a prop `consultaAtual` do Prontuario.js a ser atualizada, recarregando o formulário.
        if (updatedAppointment.consulta) {
          setProntuarioData(prev => ({ ...prev, consultaAtual: updatedAppointment.consulta }));
        }
        // --- FIM DA CORREÇÃO ---
        setPacienteSelecionado(prev => {
          const servicosAtuais = prev.servicosDoAgendamento || [];
          const novosServicos = updatedAppointment.consulta.servicos || [];

          // Unifica as listas, garantindo que não haja serviços duplicados pelo ID
          const servicosMap = new Map();
          servicosAtuais.forEach(s => servicosMap.set(s.id, s));
          novosServicos.forEach(s => servicosMap.set(s.id, s));

          const servicosUnificados = Array.from(servicosMap.values());
          return { ...prev, servicosDoAgendamento: servicosUnificados };
        });
      }

      // Incrementa a chave para forçar a atualização nos componentes filhos (AgendasCardTab)
      setAgendaRefreshKey(prev => prev + 1);
    } else {
      // Fallback: Se nenhum agendamento for passado, força refresh geral
      setAgendaRefreshKey(prev => prev + 1);
      fetchOrdemDeChegada();
    }
  }, [fetchOrdemDeChegada]); 

  // NOVO useEffect: Busca dados específicos do MÉDICO somente quando o médico selecionado muda.
  useEffect(() => {
    if (selectedMedico && currentEntidade && !isLoadingEntidade && currentUserRole) {
      // A busca de disponibilidade do mês é importante para a Recepção/Admin,
      // mas não é essencial para o Médico, que foca no dia.
      // if (currentUserRole !== 'Médico') {
      //   fetchMonthAvailability();
      // }
      fetchOrdemDeChegada();
      
    }
  }, [selectedMedico, currentEntidade, isLoadingEntidade, currentUserRole, fetchOrdemDeChegada]);
  // Obter todas as abas permitidas para o módulo 'consultorio' com base na role

  // Função para buscar os dados do prontuário (histórico e consulta atual) - RESTAURADA
  const fetchProntuarioData = useCallback(async (paciente, options = {}) => {
    const { force = false } = options;

    // Guard: Se não há paciente ou entidade, não faz nada.
    if (!paciente || !paciente.id || !currentEntidade) {
      // Se o paciente foi limpo (é nulo), reseta os dados e a ref para permitir uma nova busca no futuro.
      if (!paciente) {
        setProntuarioData({ historico: [], consultaAtual: null });
        prontuarioFetchedForIdRef.current = null;
      }
      return;
    }
    // Guard: Se não for forçado, e os dados para este paciente já foram buscados, não faz nada.
    if (!force && prontuarioFetchedForIdRef.current === paciente.id) {
      return;
    }

    prontuarioFetchedForIdRef.current = paciente.id;
      // OTIMIZAÇÃO: Se o histórico já foi injetado no objeto 'paciente', usamos ele.
      // Caso contrário, buscamos na API.
      const historicoPromise = (paciente.historico)
        ? Promise.resolve({ data: { paciente: { consultas: paciente.historico } } })
        : axios.get(`/api/pacientes/${paciente.id}/consultas`);

      // OTIMIZAÇÃO: Se a consulta atual já foi injetada no objeto 'paciente' pelo AgendasTab,
      // usamos ela diretamente. Caso contrário, buscamos na API.
      const consultaAtualPromise = (paciente.consultaAtual)
        ? Promise.resolve({ data: paciente.consultaAtual }) // A API retorna o objeto consulta diretamente
        : (paciente.agendamento_id && paciente.agendamento_status === 'Em andamento')
          ? axios.get(`/api/agendamentos/${paciente.agendamento_id}`) // CORREÇÃO: Usar a rota de agendamentos
          : Promise.resolve({ data: null });



      const [historicoRes, consultaAtualRes] = await Promise.all([historicoPromise, consultaAtualPromise]);

      const sortedConsultas = (historicoRes.data.paciente.consultas || []).sort((a, b) => b.id - a.id);
        // .sort((a, b) => new Date(b.data_consulta) - new Date(a.data_consulta));

      let consultaAtualData = consultaAtualRes.data; // A API retorna o objeto diretamente

      // Se não há uma consulta salva, mas há um agendamento em andamento, buscamos os serviços do agendamento
      if (!consultaAtualData && paciente.agendamento_id && paciente.agendamento_status === 'Em andamento') {
        const agendamentoRes = await axios.get(`/api/agendamentos/${paciente.agendamento_id}`);
        const servicosDoAgendamento = agendamentoRes.data?.servicos || [];
        // Criamos um objeto 'consultaAtual' temporário para popular o formulário
        consultaAtualData = {
          // Inclui o agendamento completo para que o Prontuario.js tenha acesso
          agendamento: agendamentoRes.data, 
          queixa_principal: '',
          observacoes: '',
          servicos: servicosDoAgendamento, // Passamos os serviços do agendamento
          isNew: true // Flag para indicar que é uma nova consulta
        };
      }

      // Guard: If the newly fetched data is identical to what's already in the state, skip the update.
      if (lastSetProntuarioDataRef.current &&
          JSON.stringify(lastSetProntuarioDataRef.current.historico) === JSON.stringify(sortedConsultas) &&
          JSON.stringify(lastSetProntuarioDataRef.current.consultaAtual) === JSON.stringify(consultaAtualData)) {
        return;
      }

      const newProntuarioData = { historico: sortedConsultas, consultaAtual: consultaAtualData };
      setProntuarioData(newProntuarioData);
      lastSetProntuarioDataRef.current = newProntuarioData; // Store the content for future comparison
    
  }, [currentEntidade]); // A dependência é apenas `currentEntidade` para estabilidade.

  const allPermittedTabs = useMemo(() => {
    return getPermittedInternalTabs('consultorio', currentUserRole);
    },
    [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig, dynamicAccessConfig]
  );

  // NOVO: Callback específico para quando a consulta é apenas SALVA (sem finalizar)
  const handleConsultaSaved = useCallback((updatedConsulta) => {
    // Atualiza apenas os dados da consulta no estado do prontuário,
    // sem recarregar toda a agenda.
    setProntuarioData(prev => ({ ...prev, consultaAtual: updatedConsulta }));
  }, []);

  // NOVO: Callback para ser chamado pelo Prontuario.js após finalizar
  const handleConsultaFinalizada = useCallback(() => {
    setPacienteSelecionado(null); // Limpa o paciente do cabeçalho
    handleAppointmentStatusUpdated(); // Força a atualização das listas da agenda
  }, [setPacienteSelecionado, handleAppointmentStatusUpdated]);

  // Memoiza a instância do componente Prontuario para evitar recriação desnecessária
  const prontuarioComponent = useMemo(() => (
    <Prontuario 
      historico={prontuarioData.historico}
      consultaAtual={prontuarioData.consultaAtual}
      servicos={supportData.servicos} // Passa a lista de todos os serviços
      fetchProntuarioData={fetchProntuarioData} // Passa a função como prop
      servicosDoAgendamento={prontuarioData.consultaAtual?.agendamento?.servicos} // Reintroduz a prop
      onAppointmentStatusChange={handleAppointmentStatusUpdated} // Passa o callback de atualização
      onConsultaSaved={handleConsultaSaved} // NOVO: Passa o callback de salvamento
      onConsultaFinalizada={handleConsultaFinalizada} // NOVO: Passa o callback de finalização
      setIsScreenLocked={setIsScreenLocked} // NOVO: Passa o setter para o Prontuário
    />
  ), [prontuarioData, supportData.servicos, fetchProntuarioData, handleAppointmentStatusUpdated, handleConsultaSaved, handleConsultaFinalizada]);

  // Filter permitted tabs based on patient selection and status for rendering
  const renderedTabs = useMemo(() => {
    return allPermittedTabs.filter(tabInfo => {
      // CORREÇÃO: A aba Agenda (e Pacientes) só deve aparecer se não houver consulta em andamento.
      if (tabInfo.key === 'agenda') {
        return !pacienteSelecionado;
      }

      // Pacientes tab: show if permitted AND no patient selected
      if (tabInfo.key === 'pacientes') {
        return !pacienteSelecionado;
      }
      // Tabs related to active consultation: show if permitted AND patient selected AND status 'Em andamento'
      const activeConsultationTabs = ['prontuario', 'historico', 'anamnese', 'laudo', 'relatorio', 'exames', 'pedidos', 'atestado', 'conferencia'];
      if (activeConsultationTabs.includes(tabInfo.key)) {
        return pacienteSelecionado && pacienteSelecionado.agendamento_status === 'Em andamento';
      }
      // By default, hide any other tabs not explicitly handled
      return false;
    });
  }, [allPermittedTabs, pacienteSelecionado]); // Re-filter when allPermittedTabs or pacienteSelecionado changes

  // Define the active tab key. Initialize with 'agenda'.
  // 2. Define o estado inicial da aba com base no que foi passado pela navegação, ou 'agenda' como padrão.
  const [key, setKey] = useState(() => {
    return location.state?.activeTab || 'agenda';
  });

  // Effect to FETCH data only when the patient ID changes.
  // This is kept separate to avoid re-fetching data on every re-render caused by context changes.
  useEffect(() => {
    if (pacienteSelecionado?.id) {
      fetchProntuarioData(pacienteSelecionado);
      setKey('prontuario');
    } else {
      // Paciente was cleared, clear the data and reset the fetch guard.
      fetchProntuarioData(null);
    }
  }, [pacienteSelecionado?.id, fetchProntuarioData]);

   // Função para retomar o atendimento
  const handleRetomarAtendimento = () => {
    if (lastActivePatientContext) {
      setPacienteSelecionado(lastActivePatientContext); // Restaura o paciente
      setLastActivePatientContext(null); // Limpa o estado do paciente "pausado"
      setKey('prontuario'); // Navega para a aba Prontuário
    }
  };

  // Função de callback para atualizar os interesses de um paciente na lista local
  const handlePatientInterestsUpdate = (pacienteId, novosInteresses) => {
    // A lista de pacientes agora é gerenciada pelo EntidadeContext.
    // Esta função foi desativada pois a atualização de interesses
    // deve ser refletida no contexto, não em um estado local.
    // A lógica de atualização foi movida para o EntidadeContext.
    // setPacientesList(currentList => {
    //   // Encontra o índice do paciente que precisa ser atualizado.
    //   const patientIndex = currentList.findIndex(p => p.id === pacienteId);

    //   // Se o paciente não for encontrado, retorna a lista sem modificações.
    //   if (patientIndex === -1) {
    //     return currentList;
    //   }

    //   // Pega o objeto do paciente original.
    //   const pacienteOriginal = currentList[patientIndex];

    //   // Converte os novos interesses do formato { value, label } para o formato { id, nome }.
    //   const interessesFormatados = novosInteresses.map(tag => ({
    //     id: tag.value,
    //     nome: tag.label,
    //   }));

    //   // Cria o objeto do paciente atualizado, combinando os interesses antigos com os novos.
    //   const pacienteAtualizado = {
    //     ...pacienteOriginal,
    //     interesses: [...(pacienteOriginal.interesses || []), ...interessesFormatados]
    //   };

    //   // Cria uma nova lista para garantir a imutabilidade e a re-renderização do React.
    //   const novaListaDePacientes = [...currentList];
    //   novaListaDePacientes[patientIndex] = pacienteAtualizado;

    //   return novaListaDePacientes;
    // });
  };

  return (
    <div className="w-100" style={{ border: '1px solid gray', backgroundColor: '#f5f5f5' }}> 
       {/* Adiciona um min-height para evitar que o layout pule */}
       <div className="header" style={{ minHeight: '80px' }}> 
        <Row className="p-1 align-items-center" style={{ minHeight: 'inherit' }}> {/* Garante que a Row ocupe a altura mínima */}
            <Col xs={12} md={6} style={{ minHeight: '60px', ...(isMdDevice ? { flex: '0 0 60%', maxWidth: '60%' } : {}) }}> {/* Adiciona uma altura mínima à coluna */}
            {currentUserRole === 'Médico' && pacienteSelecionado ? ( // Verifica se é médico e se há paciente selecionado
                  <div className="d-flex align-items-center">
                    {/* Foto do Paciente ou Placeholder */}
                    {pacienteSelecionado.foto_path ? (
                      <Image
                        src={`${config.apiBaseURL}/storage/${pacienteSelecionado.foto_path}`}
                        alt="Foto do Paciente"
                        style={{
                          width: '57px', // Aproximadamente 1.5cm
                          height: '76px', // Aproximadamente 2cm
                          objectFit: 'cover',
                          marginRight: '15px',
                          marginLeft: '12px',
                          border: '1px solid #dee2e6'
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '57px', height: '76px', marginRight: '15px', marginLeft: '12px',
                        border: '1px solid #dee2e6', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', backgroundColor: '#e9ecef'
                      }}>
                        <span style={{ fontSize: '12px', color: '#6c757d' }}>Sem Foto</span>
                      </div>
                    )}
                    {/* Informações do Paciente */}
                    <div>
                      <h5 className="mb-0">Paciente: {pacienteSelecionado.nome}</h5>
                      <small className="text-muted d-block">{pacienteSelecionado.email} - CPF: {pacienteSelecionado.cpf}</small>
                      {pacienteSelecionado.agendamento_status === 'Em andamento' && pacienteSelecionado.data_agendamento && pacienteSelecionado.hora_marcada && (
                        <small className="text-info d-block">
                          {`Consulta ${pacienteSelecionado.agendamento_status} - ${pacienteSelecionado.data_agendamento.split('-').reverse().join('/')} às ${pacienteSelecionado.hora_marcada.slice(0, 5)}`}
                        </small>
                      )}
                    </div>
                  </div>
                  ) : (
                    // Renderiza a logo se não houver paciente selecionado
                    <div className="d-flex align-items-center justify-content-start h-100" style={{ marginLeft: isMobile ? '5px' : '19px' }}> {/* Alinha a logo */}
                      <Image 
                        src={logoImage} 
                        alt="Logo Clínica" 
                        style={{ 
                          maxHeight: isMobile ? '35px' : (isTablet ? '45px' : '60px'),
                          marginLeft: isMobile ? '5px' : '12px'
                        }} 
                      /> 
                      <h3 style={{ 
                        marginLeft: isMobile ? '8px' : '15px', 
                        marginBottom: '0',
                        fontSize: isMobile ? '1rem' : (isTablet ? '1.25rem' : '1.75rem')
                      }}>
                        Gestão de Agendamentos e pacientes
                      </h3>
                    </div>
          )}
           </Col>

          <Col xs={12} md={currentUserRole === 'Médico' ? 6 : 12} className="text-end"> 

            {/* Botão Retomar Atendimento */}
            {currentUserRole === 'Médico' && !pacienteSelecionado && lastActivePatientContext && (
              <Button variant="info" className="me-2" onClick={handleRetomarAtendimento}>
                Retomar Atendimento ({lastActivePatientContext.nome})
              </Button>
            )}
            
          </Col>
        </Row>
      </div>

      <div className={`body ${isMobile ? '' : 'p-3'}`} style={isMobile ? { padding: '0.3rem' } : {}}>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >

          { /* Renderiza as abas permitidas dinamicamente */ }
          {renderedTabs.map(tabInfo => {
            let tabContent = null;

            // Conditionally render content based on the tab key
            if (tabInfo.key === 'agenda') {
              tabContent = <AgendaTab 
                isActive={key === tabInfo.key} 
                especialidades={supportData.especialidades}
                todosMedicos={supportData.todosMedicos}
                allFuncionarios={supportData.allFuncionarios} // Passa a lista completa de funcionários
                servicos={supportData.servicos}
                pacientesList={supportData.pacientesList} // Passa a lista de pacientes
                selectedEspecialidade={selectedEspecialidade} // Passa o estado
                setSelectedEspecialidade={setSelectedEspecialidade} // Passa o setter
                selectedMedico={selectedMedico} // Passa o estado
                setSelectedMedico={setSelectedMedico} // Passa o setter
                selectedDate={selectedDate} // Passa o estado
                setSelectedDate={setSelectedDate} // Passa o setter
                calendarAppointments={calendarAppointments} // Passa os agendamentos do dia
                isLoadingCalendarData={isLoadingCalendarData} // Passa o loading
                // Props relacionadas a horários e feriados
                horariosAtendimento={horariosAtendimento}
                totalSlotsDisponiveis={totalSlotsDisponiveis}
                getFeriadoNome={getFeriadoNome}
                isDiaBloqueado={isDiaBloqueado} // Passa a nova função
                agendaHorariosGerados={currentEntidade?.agenda_horarios_gerados} // Passa a config de horários da semana
                // Callbacks para atualizar os dados no Consultorio.js (agora com atualização local)
                onAppointmentCreated={handleAppointmentStatusUpdated}
                onAppointmentStatusChange={handleAppointmentStatusUpdated} // Mantém para atualizações de status
                onAppointmentFinalized={handleAppointmentStatusUpdated}
                refreshKey={agendaRefreshKey} // Passa a chave de atualização
                isCurrentUserCorpoClinico={isCurrentUserCorpoClinico}
                ordemDeChegada={ordemDeChegada}
                isLoadingOrdemDeChegada={isLoadingOrdemDeChegada}
                onPatientInterestsUpdate={handlePatientInterestsUpdate} // Passa a nova função de callback
                // >>> INÍCIO DA ALTERAÇÃO <<<
                onPatientCreated={handlePatientCreated} // 2. Passe a função como prop
              />;
            } else if (tabInfo.key === 'pacientes') {
              tabContent = <PacientesTab 
                pacientesList={supportData.pacientesList} // Passa a lista de pacientes
                onPatientCreated={handlePatientCreated} // Passa o mesmo callback
                onPatientUpdated={handlePatientUpdate} // Passa o novo callback para atualização
                onPatientDeleted={handlePatientDeleted} // Passa o novo callback para deleção
              />; 
            } 
            // CORREÇÃO: Renderiza o prontuário se a aba for 'prontuario' OU qualquer uma de suas sub-abas internas.
            // Isso mantém o componente montado durante a navegação interna.
            else if (['prontuario', 'historico', 'alergias', 'laudos', 'documentos_historico', 'receituario', 'atestado'].includes(tabInfo.key)) {
              // **NOVA GUARDA**: Só renderiza o prontuário se a consulta atual estiver carregada.
              // Isso garante que o Prontuario.js receba as props completas desde o início,
              // evitando que ele tente processar dados incompletos e mostre a lista de procedimentos vazia.
              if (prontuarioData.consultaAtual) {
                tabContent = prontuarioComponent; // Usa a instância memoizada
              }
            }
            // Adicione mais 'else if' para outras abas permitidas em "Consultório"
            // Ex: else if (tabInfo.key === 'historico') { tabContent = <HistoricoTab />; }

            // If tabContent is still null, it means this tab is permitted and rendered,
            // but Consultorio.js doesn't have specific content rendering logic for it yet.
            // Render a placeholder.
            if (tabContent === null) {
              tabContent = <div>Carregando "{tabInfo.title}"</div>;
            }

            return (
              <Tab
                key={tabInfo.key}
                eventKey={tabInfo.key}
                title={tabInfo.title}
                // Adiciona unmountOnExit={false} especificamente para a aba 'prontuario'
                // Mantém a aba 'agenda' e 'prontuario' montadas para preservar estado e evitar recarregamentos.
                // Outras abas podem usar o comportamento padrão (desmontar ao sair).
                unmountOnExit={
                  (tabInfo.key === 'prontuario' || tabInfo.key === 'agenda') ? false : undefined
                }              >
                {tabContent}
              </Tab>
            );
          })}
        </Tabs>
      </div>

        {/* --- NOVO: Modal de Bloqueio de Tela --- */}
      <Modal
        show={isScreenLocked}
        onHide={() => {}} // Impede o fechamento pelo usuário
        backdrop="static" // Impede o fechamento ao clicar fora
        keyboard={false} // Impede o fechamento pela tecla ESC
        centered
        dialogClassName="modal-loading" // Classe para estilização customizada
      >
        <Modal.Body className="text-center">
          <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
          <h5 className="mt-3">Processando...</h5>
          <p className="text-muted">Por favor, aguarde.</p>
        </Modal.Body>
      </Modal>

    </div>
  )
};

export default Consultorio;